import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 24, height = 24, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 20 20'>
  <path d='M9.16683 3.33329V13.475L4.5085 8.81663L3.3335 9.99996L10.0002 16.6666L16.6668 9.99996L15.4918 8.82496L10.8335 13.475V3.33329H9.16683Z' fill={color} />
</svg>
